/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import ProspectingListCard, { ProspectingListQuery } from '../prospecting/ProspectingListCard'
import { findManyProspectingMatchingEstateId } from '../../lib/rest/prospectingAPIClient'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import EstateBreadcrumb from './EstateBreadcrumb'
import { getProspectingCreateLink } from '../../lib/links/prospectingLinks'

function EstateProspectingListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const estateId = parseInt(params.id, 10)
  const estate = useRouteLoaderData<Estate>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: ProspectingListQuery = useMemo(() => ({
    ...searchParams,
    estateId: params.id
    // available: 'true',
    // equipped: estate?.equipped != null ? String(estate.equipped) : undefined,
    // furnished: estate?.furnished != null ? String(estate.furnished) : undefined,
    // transaction: [estate?.transaction],
    // type: [estate?.type]
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'prospecting_list',
    defaultMessage: 'Prospections'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <EstateBreadcrumb
          estate={estate}
          title={title}
        />

        <ProspectingListCard
          createLink={getProspectingCreateLink({ estateId })}
          fetcher={findManyProspectingMatchingEstateId}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default EstateProspectingListPage
